import {
  WSElement,
  WSGrid,
  WSList,
  WSLoader,
  WSPage,
  WSPageToolbar,
  WSSectionToolbar,
  WSText
} from "@wingspanhq/fe-component-library";
import React from "react";
import { queriesPayees, queriesPersons } from "@query";
import { useSession } from "@hooks/useSession";
import { useQueryNotifications } from "../../../../query/notifications/queries/useQueryNotifications";
import { WSQueries } from "../../../../query/WSQuery";
import { selectorPersonDisplayName } from "../../../../shared/selectors/selectorPersonDisplayName";
import { useCustomization } from "../../../customization";
import { AlertsList } from "../../components/AlertsList";
import { TodoList } from "../../components/TodoList";

export const RouteIndex: React.FC = () => {
  const { personId } = useSession();

  const queryPerson = queriesPersons.getPerson.useQuery({ personId });
  const queryPayees = queriesPayees.listPayees.useQuery({});
  const queryTasks = useQueryNotifications({
    refetchOnMount: true,
    refetchOnWindowFocus: true
  });
  const { branding } = useCustomization();

  if (!queryPerson.data) {
    return <WSLoader.Spinner size="M" m="2XL" />;
  }

  const { name: platformName } = branding(true);
  // v3 has no user account-type / payer-context flags (v1 selectorIsEnterpriseUser
  // / selectorHasPayerContextUser). A payer is derived as an account that has at
  // least one payee (a contractor it pays).
  const isPayerView = (queryPayees.data?.data?.length ?? 0) > 0;
  const userName = selectorPersonDisplayName(queryPerson.data);

  return (
    <WSPage>
      <WSPageToolbar title={`Welcome to ${platformName}, ${userName}.`}>
        {isPayerView ? (
          <WSText color="gray500">
            Here are some things you need to do to make sure {userName} is up
            and running with {platformName}.
          </WSText>
        ) : (
          <WSText color="gray500">
            Here are your updates and tasks. We'll keep you informed on what
            matters.
          </WSText>
        )}
      </WSPageToolbar>

      <WSList gap="2XL">
        <WSGrid gutter="2XL">
          <WSGrid.Item
            span={{
              s: "8"
            }}
          >
            <AlertsList
              key="list"
              showAlerts={queryTasks.isSuccess}
              notifications={queryTasks.data || []}
            />

            <WSElement>
              <WSSectionToolbar title="To-do" mb="L" />
              <WSQueries queries={{ queryTasks }}>
                {({ queryTasksData }) => (
                  <TodoList notifications={queryTasksData} />
                )}
              </WSQueries>
            </WSElement>
          </WSGrid.Item>

          {/*
            Payee side panel hidden during the v3 migration. Its widgets have no
            v3 backing yet: outstanding/deposited invoice-row summaries (no v3
            summary endpoint), the payout-method eligibility requirement (v3 GET
            403s), and the promotions (no v3 activities resource). Restore once
            those v3 endpoints land. See V3_MIGRATION_TRACKER.md.
          */}
        </WSGrid>
      </WSList>
    </WSPage>
  );
};
